import { Card, Col, Flex, Row } from 'antd'

import { GetUserProfileResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  userData?: GetUserProfileResponse
  savedDoctorName?: string | null
}

export const SidaMedicalPersonnelCard = ({
  userData,
  savedDoctorName
}: Props) => {
  const { t } = useLocales()

  const doctorName =
    savedDoctorName ||
    (userData?.firstName && userData?.lastName
      ? `${userData.lastName} ${userData.firstName}`
      : '-')

  return (
    <Card title={t('sida_notification.medical_personnel')}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.doctor_name')}</Text>
            <Text weight={400}>{doctorName}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.doctor_function')}</Text>
            <Text weight={400}>-</Text>
          </Flex>
        </Col>
      </Row>
    </Card>
  )
}
